<template>
  <div ref="sidebar" id="sidebar">
    <div class="sidebar_content sidebar_head">
      <feather-icon
        @click="hiddenModal()"
        icon="XIcon"
        svgClasses="h-6 w-6 head_icon"
      />
      <h1 class="head_title">Nro de Órden #{{ orderProcess.id }}</h1>
    </div>
    <div class="sidebar_content sidebar_body">
      <div class="body_title-wrapper">
        <p class="title_text">Procesar Órden</p>
      </div>
      <p v-if="popupOrderQuotations.error">{{ popupOrderQuotations.error }}</p>
      <!-- Caso en el que no vienen dimensiones de meli: -->
      <div v-if="showEditDataBuyerInputs">
        <p class="mb-4">
          Confirmar datos de compra
        </p>
        <div class="inputs__wrapper">
          <label for="">Calle</label>
          <input class="inputs__modals" v-model="calle" type="text">
          <label for="">Localidad</label>
          <input class="inputs__modals" v-model="localidad" type="text">
          <label for="">Cp</label>
          <input class="inputs__modals" v-model="cp" type="text">
          <label for="">Telefono</label>
          <input class="inputs__modals" v-model="telefono" type="text">
          <label for="">Email</label>
          <input class="inputs__modals" v-model="email" type="text">
        </div>
        <p class="text-right">
          <button @click="saveBuyerData()" class="button__modals">
            <feather-icon icon="FastForwardIcon" svgClasses="h-3 w-3" />
            Guardar
          </button>
        </p>
      </div>
      <div v-if="showDimensionsInputs">
        <div class="inputs__wrapper">
          <label for="">Ancho (CM)</label>
          <input class="inputs__modals" v-model="ancho" type="text" placeholder="Ancho (Cm)">
          <label for="">Largo (CM)</label>
          <input class="inputs__modals" v-model="largo" type="text" placeholder="Largo (Cm)">
          <label for="">Alto (CM)</label>
          <input class="inputs__modals" v-model="alto" type="text" placeholder="Alto (Cm)">
          <label for="">Peso (Kg)</label>
          <input class="inputs__modals" v-model="peso" type="text" placeholder="Peso (Kg)">
        </div>
        <p class="text-right">
          <button @click="qouteWithCustomDimensions()" class="button__modals">
            <feather-icon icon="FastForwardIcon" svgClasses="h-3 w-3" />
            Continuar
          </button>
        </p>
      </div>
      <div v-if="isLoading" class="text-center pt-16">
        <spinner size="50" :line-fg-color="$brandColor"></spinner>
      </div>
      <p v-if="popupOrderQuotations.fetching" class="text-center">
        ...Obteniendo cotizaciones...
      </p>
      <!-- Se muestran las cotizaciones disponibles y boton de procesar-->
      <div v-if="popupShowQuotations">
        <p class="mb-4">
          <strong>Cotizaciones</strong> - seleccione una para procesar
        </p>
        <div class="shipping__wrapper">
          <div class="shipping__type" 
          v-for="(quote, index) in popupOrderQuotations.available"
            :class="[(popupOrderQuotations.choosen === quote.CodigoLinea) ? 'shipping__type--active' : '']"
            :key="index" 
            @click="popupOrderQuotations.choosen = quote.CodigoLinea">
              <div class="shipping__left">
                <p class="shipping__hours">{{ quote.HorasDesdeHastaTxt }}</p>
                <p class="shipping__text">{{ quote.Descripcion }}</p>
              </div>
              <div class="shipping__right">
                <p class="shipping__cash">{{ quote.ValorTxt }}</p>
              </div>
            </div>
        </div>
  
        <p class="text-right">
          <button @click="processOrder()" class="button__modals mt-4">
            <feather-icon icon="FastForwardIcon" svgClasses="h-3 w-3" />
            Procesar
          </button>
        </p>
      </div>

      <p v-if="isProcessingOrder">
        ...Procesando órden #{{ popupOrder.id }}...
      </p>

      <p v-show="processingErrorMsg">{{ processingErrorMsg }}</p>
      <p v-show="processingSuccessMsg">{{ processingSuccessMsg }}</p>

    </div>
  </div>
</template>

<script>
import { showSuccess } from '../../../../services/alert.service';
// Los filtros formatDate/formatDateFromNow usaban moment sin importarlo.
import moment from 'moment';
import Spinner from 'vue-simple-spinner'
import axios from "axios";
import { translateShipmentMode } from "../../../../utils/orderLabels";
axios.defaults.withCredentials = true;

export default {
  name: "PedingProcess",
  data() {
    return {
      orders: [],
      ordersPreserved: [], // used when reseting local filtering
      totalItems: 0, // SST
      selected: [], // Los items seleccionados con el checkbox

      // Popup (detalle & proccesar)
      popupOrder: {}, // El item en que se ha clickeado Detalle o Procesar
      popupOrderShipmentInfo: null,

      // Popup - detalle
      popupDetalleActive: false,
      // Popup - procesar
      popupProcesarActive: false,

      // Popup - procesar - cotizar
      popupOrderQuotations: {
        available: [],
        fetching: false,
        choosen: null,
        error: null, //
      },

      ancho: null,
      largo: null,
      alto: null,
      peso: null,
      calle: null,
      localidad: null,
      cp: null,
      telefono: null,
      email: null,

      isLoading: false,
      // Popup - procesar - despachar
      isProcessingOrder: false,
      showDimensionsInputs: false,
      showEditDataBuyerInputs: false,
      processedOrder: false,
      processingErrorMsg: "",
      processingSuccessMsg: "",

      processManyShowPopup: false,
    };
  },
  props: {
    orderProcess: Object
  },
  components: {
    Spinner
  },
  mounted() {
    document.getElementById("sidebar").classList.add("show");
    this.setOrderData(this.orderProcess);
    this.openPopupProcesar(this.orderProcess);
  },
  computed: {
    /**
     * @bool Se deben mostrar las posibles cotizaciones para seleccioanr una?
     */
    popupShowQuotations() {
      return (
        this.popupOrderQuotations.available.length &&
        !this.isProcessingOrder &&
        !this.processedOrder
      );
    },

    qoutationCustomDimensionsEnableContinue() {
      return this.ancho && this.alto && this.largo && this.peso;
    },
  },

  filters: {
    formatDate(rawDate) {
      return moment(rawDate).format("D-M-Y");
    },
    formatDateFromNow(rawDate) {
      return moment(rawDate).fromNow();
    },
    translateShipmentMode,
  },

  methods: {
    hiddenModal() {
      document.getElementById("sidebar").classList.remove("show");
      this.$emit("closeModal");
    },
 /**
     * Abre popup de procesar la orden, solicita detalles de la orden y cotizaciones al backend
     * y las presenta como opciones
     */
     async openPopupProcesar(orderData) {
      // this.resetPopupProcesar();
      this.popupOrder = orderData;
      this.showEditDataBuyerInputs = true;
      //this.popupOrderShipmentInfo = await this.fetchOrderShipmentInfo(orderData.shipping.id);// Esta llamada deberia estar integrada en el back a la de ordenes recientes
      // para no volver a llamar al backed usar la info de shipment que ya tengo en order.shipment_data
      this.popupOrderShipmentInfo = orderData.shipment_data;
      this.calle = orderData.buyer_street ? orderData.buyer_street: this.popupOrderShipmentInfo.receiver_address.address_line;
      this.localidad = orderData.buyer_city ? orderData.buyer_city: this.popupOrderShipmentInfo.receiver_address.city.name;
      this.cp = orderData.buyer_zip ? orderData.buyer_zip: this.popupOrderShipmentInfo.receiver_address.zip_code;
      this.telefono = orderData.buyer_phone ? orderData.buyer_phone: this.popupOrderShipmentInfo.receiver_address.receiver_phone;

      this.popupProcesarActive = true;    
    },
    async quoteOrder() {
      this.isLoading = true;      
      try {
        let r = await axios.post(
          process.env.VUE_APP_BACKEND_URL +
            "api/quote-order/" +
            this.popupOrder.id
        );
        if (r.data.error) {
          this.popupOrderQuotations.error = r.data.error;
          this.popupOrderQuotations.errorKey = r.data.error_key;
        }

        this.popupOrderQuotations.available = r.data;

        this.ancho = r.data.ancho;
        this.largo = r.data.largo;
        this.alto = r.data.alto;
        this.peso = r.data.peso;
        this.showDimensionsInputs = true;

      } catch (e) {
        console.log(e);
      }
      this.popupOrderQuotations.fetching = false;
      this.isLoading = false;  
    },
    async saveBuyerData() {
      this.isLoading = true;  
      let data = {
        calle: this.calle,
        localidad: this.localidad,
        cp: this.cp,
        telefono: this.telefono,
        email: this.email
      }
      try {
        await axios.post(
          process.env.VUE_APP_BACKEND_URL +
            "api/orders/" +
            this.popupOrder.id,
            data
        );

        this.quoteOrder();
      } catch (error) {
        console.log(error)
      }

      this.isLoading = false;  
    },
    async ver(data) {
      console.log(data)
    },
    /**
     * Envia las dimesiones ingresdas por el merchant (cuando no habia dimensiones de meli)
     * y obtinene las cotizaciones.
     */
     async qouteWithCustomDimensions() {
      this.popupOrderQuotations.fetching = true;
      this.popupOrderQuotations.error = null;
      this.popupOrderQuotations.errorKey = null;
      try {
        let r = await axios.post(
          process.env.VUE_APP_BACKEND_URL +
            "api/quote-order-custom-dimensions/" +
            this.popupOrder.id,
          {
            ancho: this.ancho,
            largo: this.largo,
            alto: this.alto,
            peso: this.peso,
          }
        );
        if (r.data.error) {
          this.popupOrderQuotations.error = r.data.error;
          this.popupOrderQuotations.errorKey = r.data.error_key;
        }
        this.popupOrderQuotations.available = r.data;
        console.log("---> :", this.popupOrderQuotations);
        if (this.popupOrderQuotations.available.length > 0) {
          this.popupOrderQuotations.choosen =
            this.popupOrderQuotations.available[0].CodigoLinea;
        }
        console.log(" --> :", this.popupOrderQuotations);
        console.log(r.data);
      } catch (e) {
        console.log("error recotizando");
        console.log(e);
      }
      this.popupOrderQuotations.fetching = false;
    },
    /**
     * Abre popup de detalle de la orden
     */
     async setOrderData(orderData) {
      this.popupOrder = orderData;
      this.popupOrderShipmentInfo = orderData.shipping;
      this.isLoading = false;      
      this.popupDetalleActive = true;      
    },

     /**
     * Inicia el procesamiento de una orden con la cotizacion selccionada
     */
     async processOrder() {
      this.isProcessingOrder = true;
      this.showDimensionsInputs = false;
      /**
       * Select by default
       */
      console.log("SELECT", this.popupOrderQuotations);

      if (!this.popupOrderQuotations.choosen) {
        this.popupOrderQuotations.choosen =
          this.popupOrderQuotations.available[0].CodigoLinea;
      }

      try {
        let r = await axios.post(
          process.env.VUE_APP_BACKEND_URL +
            "api/process-order/" +
            this.popupOrder.id +
            "/" +
            this.popupOrderQuotations.choosen
        );
        if (r.data.error) {
          this.processingErrorMsg = r.data.msg;
        } else if (
          r.data.despacho &&
          r.data.despacho.Respuesta[0].Estado === 0
        ) {
          //se proceso correctamente
          showSuccess({message: "¡Se ha procesado con exito!"});
          this.processingSuccessMsg = r.data.msg;
          // remover la orden
          this.$emit("orderProcess");
        }
      } catch (e) {
        console.log(e);
      }
      this.processedOrder = true;
      this.isProcessingOrder = false;
    },

    /**
     * Reinicia el estado del popup de procesar
     */
    resetPopupProcesar() {
      this.popupOrderQuotations = {
        available: [],
        fetching: false,
        choosen: null,
        error: null,
      };
      this.isProcessingOrder = false;
      this.processedOrder = false;
      this.processingErrorMsg = "";
      this.processingSuccessMsg = "";
      this.ancho = null;
      this.largo = null;
      this.alto = null;
      this.peso = null;
    }, 

    async fetchOrderShipmentInfo(shipmentId) {
      try {
        let shipmentInfo = await axios.get(
          process.env.VUE_APP_BACKEND_URL +
            "api/order-shipment-info/" +
            shipmentId
        );
        console.log(shipmentInfo);
        if (shipmentInfo.data) {
          //this.popupOrderShipmentInfo = shipmentInfo.data
          return shipmentInfo.data;
        }
      } catch (e) {
        console.log(e);
      }
    },
  }
};
</script>
